import { Logo, LogoFooter } from 'iovisit-museum-cremona/components/layout';
import { useGoogleAnalytics } from 'volto-google-analytics';
//import { serveStaticResources } from 'volto-middleware-static';
import favicon from 'iovisit-museum-cremona/static/favicon.ico';
import appleTouchIcon from 'iovisit-museum-cremona/static/apple-touch-icon.png';
import favicon16 from 'iovisit-museum-cremona/static/favicon-16x16.png';
import favicon32 from 'iovisit-museum-cremona/static/favicon-32x32.png';
import safariPinnedTab from 'iovisit-museum-cremona/static/safari-pinned-tab.svg';
import { Helmet } from '@plone/volto/helpers';

/**
 * src/index.jsx
 *
 * Customizations:
 * - added titleTemplate to appExtras
 * - import Helmet component
 *
 */

const GoogleAnalytics = () => {
  useGoogleAnalytics();
  return <></>;
};

const applyConfig = (config) => {
  config.settings.isMultilingual = true;
  config.settings.supportedLanguages = ['it', 'en'];
  config.settings.iovisit.siteName = 'CREMONA MUSEI';
  config.settings.iovisit.logo = Logo;
  config.settings.iovisit.logoFooter = LogoFooter;
  config.settings.iovisit.topLink = {
    text: null,
    url: null,
  };
  config.settings.iovisit.subscribeNewsletterLink =
    'https://a4g6h2.emailsp.com/frontend/forms/Subscription.aspx?idList=1&idForm=9&guid=aafa5375-bcf1-4e06-965a-e3a98b626156';

  config.settings.iovisit.favicon = [
    { rel: 'icon', sizes: 'any', href: favicon },
    { rel: 'icon', sizes: '16x16', href: favicon16 },
    { rel: 'icon', sizes: '32x32', href: favicon32 },
    { rel: 'apple-touch-icon', sizes: '180x180', href: appleTouchIcon },
    { rel: 'mask-icon', color: '#000', href: safariPinnedTab },
  ];

  config.settings.matomoSiteId = 'jKq2v5eqlV';
  config.settings.matomoUrlBase = 'https://ingestion.webanalytics.italia.it/';
  config.settings.appExtras = [
    ...config.settings.appExtras,
    {
      match: '',
      component: () => <Helmet titleTemplate={`%s - Cremona Musei`} />, //load fontawesom dom css
    },
    {
      match: '',
      component: GoogleAnalytics,
    },
  ];

  config.settings['volto-gdpr-privacy'] = {
    ...config.settings['volto-gdpr-privacy'],
    defaultPanelConfig: {
      ...config.settings['volto-gdpr-privacy'].defaultPanelConfig,
      last_updated: '2022-02-17T15:14:00+00:00',
      technical: {
        ...config.settings['volto-gdpr-privacy'].defaultPanelConfig.technical,
        choices: [
          ...config.settings['volto-gdpr-privacy'].defaultPanelConfig.technical
            .choices,
          {
            config_key: 'MATOMO',
            text: {
              it: {
                title: 'Matomo',
                description:
                  "I cookie di Matomo sono usati per analizzare la navigazione sul sito al fine di migliorarla e fornire all'utente un'esperienza di navigazione migliore possibile.",
              },
              en: {
                title: 'Matomo',
                description:
                  'Matomo cookie are used to analyze navigation on the site in order to improve it and provide the user with the best possible browsing experience.',
              },
              fr: {
                title: 'Matomo',
                description:
                  "Les cookie de Matomo sont utilisés pour analyser la navigation sur le site afin de l'améliorer et offrir à l'utilisateur la meilleure expérience de navigation possible.",
              },
            },
          },

          // ...config.settings[
          //   'volto-gdpr-privacy'
          // ].defaultPanelConfig.technical.choices.filter(
          //   (f) => f.config_key !== 'GANALYTICS',
          // ),
        ],
      },
    },
  };

  return config;
};

export default applyConfig;
